import { Tabs, UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';
import { useCallback } from 'react';
import { EUserCardTab } from './types';
import styles from './UserCardSwitcher.css';
import { USER_CARD_SWITCHER_TABS_CONFIG } from './constants';

interface IProps {
  tabs: EUserCardTab[];
  activeTab: EUserCardTab;
  onTabChange(tab: EUserCardTab): void;
}

export const UserCardSwitcher = (props: IProps) => {
  const { tabs, activeTab, onTabChange } = props;

  const activeTabIndex = tabs.indexOf(activeTab);

  const handleTabClick = useCallback(
    (index: number) => {
      onTabChange(tabs[index]);
    },
    [tabs, onTabChange],
  );

  if (tabs.length === 1) {
    return (
      <div className={styles['wrapper']}>
        <UIHeading5>{USER_CARD_SWITCHER_TABS_CONFIG[tabs[0]].text}</UIHeading5>
      </div>
    );
  }

  return (
    <div className={styles['wrapper']}>
      {/** Этот div нужен чтобы спозиционировать табы по центру родительского блока */}
      <div>
        <Tabs
          items={tabs.map(tab => USER_CARD_SWITCHER_TABS_CONFIG[tab])}
          activeTabIndex={activeTabIndex}
          onTabClick={handleTabClick}
        />
      </div>
    </div>
  );
};
